// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFound-root-lAzDG {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 100px;
  padding-bottom: 30px;
}

.NotFound-container-w_y0d {
  margin: 0 auto;
  padding: 0 0 40px;
  max-width: var(--max-content-width);
}

.NotFound-imgWidth-Ve5hD {
  width: 100%;
  max-width: 350px;
}

.NotFound-textAlignCenter-p7i4U {
  text-align: center;
}

.NotFound-notFoundTitle-R3MRL {
  font-size: 30px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/NotFound/NotFound.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".root {\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 100px;\n  padding-bottom: 30px;\n}\n\n.container {\n  margin: 0 auto;\n  padding: 0 0 40px;\n  max-width: var(--max-content-width);\n}\n\n.imgWidth {\n  width: 100%;\n  max-width: 350px;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n.notFoundTitle {\n  font-size: 30px;\n  margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NotFound-root-lAzDG`,
	"container": `NotFound-container-w_y0d`,
	"imgWidth": `NotFound-imgWidth-Ve5hD`,
	"textAlignCenter": `NotFound-textAlignCenter-p7i4U`,
	"notFoundTitle": `NotFound-notFoundTitle-R3MRL`
};
module.exports = ___CSS_LOADER_EXPORT___;
